import React from 'react';
import { Twitter } from 'lucide-react';
import MoonLogo from './MoonLogo';

const Footer = () => {
  return (
    <footer className="relative py-12 bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Logo and brand */}
          <div className="flex items-center space-x-2">
            <MoonLogo size={32} />
            <span className="text-white font-semibold text-lg tracking-wide">moon<span className="text-[#f2e2a6]">.land</span></span>
          </div>

          {/* Links */}
          <div className="flex items-center space-x-8">
            <a href="https://t.me/ArbXSignalsBot" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#f2e2a6] transition-colors text-sm">
              Contact Support on Telegram
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#f2e2a6] transition-colors">
              <Twitter className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 text-center text-gray-500 text-sm">
          <p>© 2026 moon.land. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
